const filterGroupOperatorClassName =
    'h-6 w-auto rounded-full px-2.5 py-0 font-medium text-blue-500 ring-gray-200';

const operatorClassName = 'basis-min-content px-2 py-0 h-auto font-medium text-blue-500 ring-0';

export { operatorClassName, filterGroupOperatorClassName };
